/* @flow */

import clsx from 'clsx';
import * as React from 'react';
import { useResizeDetector } from 'react-resize-detector';

import './ResizeDetectorWrapper.css';

type RefreshModeType = 'throttle' | 'debounce';

export type ResizeType = { entry: ResizeObserverEntry, height: number | null, width: number | null };

type ResizeDetectorWrapperPropType = {
  +children?: React.Node,
  +className?: string,
  +handleHeight?: boolean,
  +handleWidth?: boolean,
  +onResize?: (data: ResizeType) => void,
  +refreshMode?: RefreshModeType,
  +refreshRate?: number,
};

const ResizeDetectorWrapper = ({ children, className, handleHeight = false, handleWidth = false, onResize, refreshMode, refreshRate }: ResizeDetectorWrapperPropType): React.Node => {
  const { ref } = useResizeDetector({ handleHeight, handleWidth, onResize, refreshMode, refreshRate });

  if (children) {
    return (
      <div className={clsx('resizeDetector', 'withChildren', className)} ref={ref}>
        {children}
      </div>
    );
  }

  return <div className='resizeDetector' ref={ref} />;
};

export default ResizeDetectorWrapper;
